import {
  DndProvider,
  MultiBackend,
  getBackendOptions,
} from '@minoru/react-dnd-treeview';
import { styled } from '@mui/material';
import { useLayoutEffect, useState } from 'react';
import { CONTAINER_EL_ID } from './constants';

const Container = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    padding: theme.spacing(0, 1.5, 0),
    width: '100%',
    '& .treeRoot': {
      width: '100%',
    },
    '& .draggingSource': {
      opacity: theme.palette.action.activatedOpacity,
    },
    ' & .dropTarget': {
      backgroundColor: theme.palette.action.selected,
    },
    '& .tree-ul': {
      listStyleType: 'none',
      paddingInlineStart: '0',
    },
    '& .placeholderContainer': {
      position: 'relative',
    },
  };
});

export const DocsTreeContainer = ({
  children,
}: { children: React.ReactNode }) => {
  const [rendered, setRendered] = useState(false);

  useLayoutEffect(() => {
    setRendered(true);
  }, []);

  return (
    <Container id={CONTAINER_EL_ID}>
      {rendered && (
        <DndProvider
          backend={MultiBackend}
          options={getBackendOptions({
            html5: {
              rootElement: document.getElementById(CONTAINER_EL_ID) as any,
            },
          })}
        >
          {children}
        </DndProvider>
      )}
    </Container>
  );
};
